import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '../../../components/atoms/button/button';
import { ErrorState } from '../../../components/molecules/error-state/error-state';
import { useClienteDetail } from '../../../hooks/use-clientes';
import { ClienteHeader } from './components/cliente-header';
import { ClienteTabs } from './components/cliente-tabs';
import { ProdutosTab } from './components/tabs/produtos-tab';
import { ResumoTab } from './components/tabs/resumo-tab';
import { VendasTab } from './components/tabs/vendas-tab';
import {
  Page,
  SkeletonBox,
  SkeletonGrid,
  TabsArea,
} from './cliente-detail.styles';

export const ClienteDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { detail, status, error, refresh } = useClienteDetail(id);
  const [activeTab, setActiveTab] = useState<string>('resumo');

  const isLoading = status === 'loading';
  const hasError = status === 'error';

  return (
    <Page>
      {isLoading && (
        <SkeletonGrid data-testid="cliente-detail-loading">
          <SkeletonBox />
          <SkeletonBox />
          <SkeletonBox />
          <SkeletonBox />
        </SkeletonGrid>
      )}

      {hasError && (
        <ErrorState
          title="Não foi possível carregar o cliente"
          description={error ?? 'Tente novamente em alguns instantes.'}
          action={
            <>
              <Button variant="secondary" onClick={() => refresh()}>
                Tentar novamente
              </Button>
              <Button variant="ghost" onClick={() => navigate('/clientes')}>
                Voltar para clientes
              </Button>
            </>
          }
        />
      )}

      {!isLoading && !hasError && detail && (
        <>
          <ClienteHeader detail={detail} />
          <TabsArea>
            <ClienteTabs activeKey={activeTab} onChange={setActiveTab} />
            {activeTab === 'resumo' && (
              <ResumoTab detail={detail} onRefresh={refresh} />
            )}
            {activeTab === 'produtos' && <ProdutosTab cliente={detail} />}
            {activeTab === 'vendas' && <VendasTab cliente={detail} />}
          </TabsArea>
        </>
      )}
    </Page>
  );
};
